import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styles from './SidebarButton.module.scss';

export interface SidebarButtonProps {
  icon?: IconProp;
  onClick?(): void;
  text?: string;
  htmlFor?: string;
  disabled?: boolean;
  ariaExpanded?: boolean;
  active?: boolean;
  hide?: boolean;
}

function SidebarButton({
  icon,
  onClick,
  text,
  htmlFor,
  disabled,
  ariaExpanded,
  active,
  hide,
}: SidebarButtonProps): JSX.Element | null {
  if (hide) {
    return null;
  }

  return (
    <div className={styles.container}>
      <label htmlFor={htmlFor} className={hide ? styles.hideButton : ''}>
        <button
          type="button"
          id={htmlFor}
          aria-expanded={ariaExpanded}
          data-testid={htmlFor}
          onClick={onClick}
          disabled={disabled}
          className={active ? styles.buttonActive : styles.buttonInactive}
        >
          {icon && <FontAwesomeIcon icon={icon} />}
        </button>
        <p>{text}</p>
      </label>
    </div>
  );
}

export default SidebarButton;
